"use client";

import { m as motion } from "framer-motion";
import { ContactForm } from "@/components/contatti/ContactForm";

export function ContactFormSection() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.1 }}
      className="flex flex-col h-full xl:self-start"
    >
      <ContactForm />
    </motion.div>
  );
}
